import { useNavigate } from "react-router-dom";
import ZionNationalPark from "../../../assets/png/Zion-National-Park.png";
import { RouterPaths } from "../../../router/router";
const Attachments = ({ NotShowBtn }) => {
  const navigate = useNavigate();

  return (
    <div className="">
      <div className="relative">
        <img src={ZionNationalPark} alt="" className="w-[-webkit-fill-available]" />
        <div
          className="
        bottom-0 
        absolute 
        text-[#F2F2F2CC] 
        font-extrabold 
        font-[Rockwell]

        2xl:text-[190px]
        lg:text-[104px]
        md:text-[85px] 
        sm:text-[65px] 
        text-[38px] 

        2xl:leading-[140px]
        lg:leading-[74px]
        md:leading-[60px] 
        sm:leading-[47px] 
        leading-[28px]

        flex justify-center items-center w-[-webkit-fill-available]"
        >
          MAKE IT YOURS
        </div>
      </div>

      {!NotShowBtn ? (
        <div className="bg-[#292929]">
          <div className="custom-container py-[40px] flex  justify-around flex-wrap items-center">
            <div className="font-[Rockwell] text-[#F2F2F2] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] text-[20px] my-[10px]">
              {" "}
              FIND ATTACHMENTS & ADD-ONS
            </div>
            <button
              className="bg-[#F2F2F2] border-[#5B792E] border-[4px] rounded font-[Roboto] 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] text-[#5B792E] lg:px-[58px] md:px-[48px] sm:px-[30px] px-[20px] lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px]"
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(RouterPaths.Attachments);
              }}
            >
              ATTACHMENTS
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};
export default Attachments;
